import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-student-promotion',
  templateUrl: './student-promotion.component.html',
  styleUrls: ['./student-promotion.component.css']
})
export class StudentPromotionComponent implements OnInit {

  constructor(private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
  StudentPromotionModel = {
    StudentID: 0,
    SessionID: 0,
    PromotionClassID: 0,
    PromotionSessionID: 0,
    ClassID: 0,
    SectionID: 0,
    ClassSectionID: null,
    ExamMapID: "0",
    AssessmentAcademicID: "0",
    ClassName: '',
    SectionName: ''
}
propertyName = 0;
reverse = true;
StudentList =[];
SessionList:any;
ClassList:any;
PromotionSectionList:any;
SectionList:any;
sortBy  (propertyName) {
    this.reverse = (propertyName !== null && this.propertyName === propertyName)
        ? !this.reverse : false;
    this.propertyName = propertyName;

};

 ValidityState() {
    return this.StudentPromotionModel.ClassID == 0;
}
Submitted = false;
GetStudentClassWise  () {
    this.StudentList =[];
    this.Submitted = true;
    if (!this.ValidityState()) {
     
        this.Submitted = false;
        this.spinnerService.show();
        this.studentService.GetStudentClassWise(JSON.stringify(this.StudentPromotionModel)).subscribe( (data)=> {
            this.StudentList = data.StudentList;
            this.spinnerService.hide();

        });
    }
}
SaveStudentPromotion  () {

    if (this.StudentPromotionModel.PromotionClassID != 0 && this.StudentPromotionModel.PromotionSessionID != 0) {
      this.spinnerService.show();
        this.studentService.SaveStudentPromotion(JSON.stringify(this.StudentPromotionModel), JSON.stringify(this.StudentList)).subscribe( (data)=> {
            this.globalHelper.CheckActionStatus(data);
            this.GetStudentClassWise();
            this.spinnerService.hide();
            this.Clear();
        });
    }
}
Clear  () {
    this.StudentPromotionModel.PromotionClassID = 0;
    this.StudentPromotionModel.PromotionSessionID = 0;
}
IsSelect:any;
PrintButton:any;
SelectAll  () {
    if (this.IsSelect) {
        for (var i = 0; i < this.StudentList.length; i++) {
            this.StudentList[i].IsActive = true;
            this.PrintButton = false;
        }
    }
    if (this.IsSelect == false) {
        for (var i = 0; i < this.StudentList.length; i++) {
            this.StudentList[i].IsActive = false;
            this.PrintButton = true;
        }
    }
}
Count1 = 0;
ChangeSelect  (item) {
    this.Count1 = 0;
    for (var i = 0; i < this.StudentList.length; i++) {
        if (this.StudentList[i].IsActive) {
            this.Count1 = this.Count1 + 1
            this.PrintButton = false;
        }
    }
    if (this.Count1 == this.StudentList.length) {
        this.IsSelect = true;
        this.PrintButton = false;
    }
    else {
        this.IsSelect = false;
    }

}
GetClass  () {
    this.lookupService.GetLookupsList('Class', '').subscribe( (data)=> {
        this.ClassList = data.LookupItems;
        });
};
GetSection  () {
    
    this.StudentPromotionModel.SectionID = 0;
    var ItemBo = {
        'ItemId': this.StudentPromotionModel.ClassID
    }
    this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.SectionList = data.LookupItems;
       
    });
};
GetPromotionSection  () {
    
    var ItemBo = {
        'ItemId': this.StudentPromotionModel.PromotionClassID
    }
    this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe( (data)=> {
        this.PromotionSectionList = data.LookupItems;
        this.PromotionSectionList.splice(0, 1);
        if (this.PromotionSectionList != null && this.PromotionSectionList.length>0) {
            for (var i = 0; i < this.StudentList.length; i++) {
                this.StudentList[i].PromotionSectionID = this.PromotionSectionList[0].ItemId;
            }
            
        }
       
    });
};

GetSession  () {
    this.lookupService.GetLookupsList('Session', '').subscribe( (data)=> {
        this.SessionList = data.LookupItems;

    });
};

 
 
  ngOnInit() {
    this.GetClass();
    this.GetSession();
    this.GetSection();
  }

}
